import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";
import { IBlock } from "../../../framework/src/IBlock";
// Customizable Area Start
import React from "react";
import {
  PaymentsIcon,
  LinkIcon,
  OldPhoneIcon,
  TodayIcon,
  WalletIcon,
  StoreIcon,
} from "../../../components/src/customComponents/PaymentModalAssets";
import { Message } from "../../../framework/src/Message";
import { getStorageData } from "../../../framework/src/Utilities";
import { IOrder } from "../../OrderCreation/src/OrderCreationController.web";
import { makeApiMessage } from "../../../components/src/common";
import { config } from "node:process";
import { emptyCartIcon } from "packages/blocks/AljabrStore/src/assets";

export const configJSON = require("./config");

export interface PaymentTransactionData {
  id: string;
  attributes: {
    store_management: {
      data: {
        id: string;
        type: string;
        attributes: {
          store_name: string;
          use_raw_printing_receipt: boolean;
        };
      };
    };
  };
}

export interface IPaymentMethod {
  id: number;
  name: string;
  active: boolean;
  enableSecond?: boolean;
  attributes: {
    icon: {
      data: {
        attributes: {
          image: string;
        };
      };
    };
  };
}

export interface IPromoCode {
  saved_amount: number;
  product_name: string;
  discount: string;
  expiry_date: null | string;
  min_order_amount: null | string;
  promo_expires: boolean;
  promo_code: string;
  description: string;
  id: number;
  currency: string;
  bogo_enabled?: boolean;
}

export interface ISidebarItems {
  key: number;
  title: string;
  apiKey?: string;
  secondKey: number;
  icon: React.ReactNode;
  enableSecond?: boolean;
}

export interface ILateDeliveryConfig {
  id: string;
  type: string;
  attributes: {
    id: number;
    name: string;
    hours: number;
    color: string;
    is_active: boolean;
    created_at: string;
    updated_at: string;
  };
}

interface OrderApiResponse {
  data?: {
    id: string;
    type: string;
    attributes: IOrder;
    applied_discount: string;
    taxable_amount: string;
    total_tax: any;
    total: string;
    qitaf_otp_time: boolean;
    discount_summary: {
      promotion_discount: string;
      coupon_discount: string;
      total_discount: string;
      is_golden_bonus_used: boolean;
      has_promotion: boolean;
      has_coupon: boolean;
      free_wash_discount: string;
      is_store_discount: boolean;
    };
  };
}

export interface GoldenPointList {
  id?: string;
  // attributes: {
  name: string;
  name_arabic: string;
  golden_point_text_en: string;
  golden_point_text_ar: string;
  base_points: number;
  bonus_points: number;
  total_points: number;
  final_price: number;
  price: number;
  imageDropdownOptions: [];
  selectedImage: null;
  searchQuery: boolean;
  isSelectedAll: boolean;
  vat: string;
  free_wash_product_quantity: number;
  mobile_description: string;
  free_wash_product_description: string;
  purchase_start_date: Date | null;
  purchase_end_date: Date | null;
  start_date_base: Date | null;
  end_date_base: Date | null;
  start_date_bonus: Date | null;
  end_date_bonus: Date | null;
  start_date_free_wash: Date | null;
  end_date_free_wash: Date | null;
  used: string;
  free_wash_description: string;
  free_wash_quentity: number;
  no_of_orders: number | null;
  status: boolean;
  all_sections_enabled: boolean;
  all_products_enabled: boolean;
  section_ids: number[];
  product_ids: number[];
  free_wash_product_ids: number[];
  service_ids: number[];
  platform_ids: number[];
  productsSelected: string[];
  freeWashProductsSelected: string[];
  productNextPage: number;
  is_redeem: boolean;
  responseIconList: number[];
}

export const initialSideBarItems: Array<ISidebarItems> = [
  {
    key: 2,
    secondKey: 1,
    title: "Cash",
    apiKey: "cash",
    enableSecond: true,
    icon: <PaymentsIcon />,
  },
  {
    title: "POS Machine",
    icon: <OldPhoneIcon />,
    key: 3,
    secondKey: 3,
  },
  {
    title: "Payment Link",
    icon: <LinkIcon />,
    key: 5,
    secondKey: 4,
  },
  {
    title: "Pay Later",
    icon: <TodayIcon />,
    key: 6,
    secondKey: 5,
    enableSecond: true,
  },
  {
    title: "Store Pay",
    icon: <StoreIcon />,
    key: 7,
    secondKey: 6,
  },
  {
    key: 4,
    secondKey: 2,
    title: "Wallets",
    apiKey: "wallets",
    enableSecond: true,
    icon: <WalletIcon />,
  },
];

// Customizable Area End

export interface Props {
  // Customizable Area Start
  open: boolean;
  handleClose: () => void;
  totalItems: number | undefined;
  taxPercentage: number | undefined | string | null;
  customerId: string;
  order?: IOrder;
  cleaningOrder?: boolean;
  onPromoCodeApply: () => void;
  onPaymentDone: (orderTransantions?: PaymentTransactionData[]) => void;
  paymentClicked: boolean;
  fromUnpaid?: boolean;
  isMainPayment?: boolean;
  goldenPointList?: Array<GoldenPointList>;
}

interface S {
  // Customizable Area Start
  activeTab: number | string;
  totalAmount: string;
  points: number;
  skipRedeemPoints: boolean;
  isRedeemAllPoints: boolean;
  isUsed: boolean;
  currency: string;
  successMessage: string;
  errorMessage: string;
  errorSnackbarOpen: boolean;
  showOtpScreen: boolean;
  otpToken: string;
  otpValue: string;
  paymentMethods: IPaymentMethod[];
  appliedDiscount: string;
  total: string;
  walletBalance: number;
  isQitafOtpComplete: boolean;
  isMokkafaOtpComplete: boolean;
  compensationCreditBalance: number;
  goldenpointBalance: number;
  goldenpointApplicableBalance: number;
  bonusPoints: number;
  expiredGoldenPoints: number;
  free_wash_quantity: number,
  free_wash_amount: number,
  goldenpointDetails: string;
  goldenPointList: GoldenPointList[];
  showGoldenDetails: boolean;
  useGoldenPoints: boolean;
  shouldUseGoldenPoints: boolean;
  isApplyingGoldenPoints: boolean;
  is_golden_bonus_used: boolean;
  goldenPointsLoaded:boolean,
  not_applicable: boolean;
  original_total: string;
  applicable_sub_total: string;
  original_tax: string; 
  order?: IOrder | null;
  secondPaymentEnabled: boolean;
  customPaymentAmount: string;
  remainBalance: number;
  latestAppliedDiscount: number;
  free_wash_discount: string;
  paymentMathod: string;
  selectedSecondPaymentMethod: string;
  selectedSecondPaymentMethodID: number;
  loading: boolean;
  isRemainingBalanceLoading: boolean;
  isPayButtonClicked: boolean;
  lateDeliveryConfigs: ILateDeliveryConfig[];
  selectedLateDeliveryConfig: string | null;
  originalOrder?: IOrder | null;
  paymentSource: "golden" | "wallet" | "compensation" | null;
   isInternalTabChange: boolean,
   edit_order: boolean,
  walletVerifyOpen: boolean;
  walletVerifyChannel: "qr" | "otp" | null;
  walletVerifyOtpCode: string;
  walletVerifyToken: string;
  walletVerifyMaskedPhone: string;
  walletVerifyExpiresAt: string;
  walletVerifySending: boolean;
  walletVerifyVerifying: boolean;
  walletVerifyOtpSent: boolean;
  walletVerified: boolean;
  walletVerifyError: string;
  walletVerifyWalletType: string;
  walletVerifyAmount: number;
  otpAttemptRights: boolean;
  isButtonDisabled: boolean;
  qitaf_otp_time: boolean;
  paymentReferenceRequired: boolean;
  paymentReferenceModalOpen: boolean;
  paymentReferenceNumber: string;
  // Customizable Area End
}
interface SS {
  id: any;
}

export default class PaymentModalController extends BlockComponent<
  Props,
  S,
  SS
> {
  latestAppliedDiscount: number = 0;
  constructor(props: Props) {
    // Customizable Area Start

    // Customizable Area End
    super(props);
    this.makePayment = this.makePayment.bind(this);
    this.receive = this.receive.bind(this);

    // Customizable Area Start
    this.subScribedMessages = [
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.SessionSaveMessage),
      getName(MessageEnum.SessionResponseMessage),
      getName(MessageEnum.RestAPIResponceSuccessMessage),
      getName(MessageEnum.RestAPIResponceErrorMessage),
      getName(MessageEnum.NavigationPayLoadMessage),
      getName(MessageEnum.RestAPIResponceDataMessage),
    ];
    // Customizable Area End

    this.state = {
      // Customizable Area Start

      activeTab: 0,
      totalAmount: "",
      currency: "",
      points: 0,
      isRedeemAllPoints: false,
      isUsed: false,
      errorMessage: "",
      errorSnackbarOpen: false,
      showOtpScreen: false,
      otpToken: "",
      otpValue: "",
      paymentMethods: [],
      appliedDiscount: "",
      total: "",
      secondPaymentEnabled: false,
      selectedSecondPaymentMethod: "",
      walletBalance: 0,
      compensationCreditBalance: 0,
      isQitafOtpComplete: false,
      isMokkafaOtpComplete: false,
      goldenpointBalance: 0,
      goldenpointApplicableBalance: 0,
      bonusPoints: 0,
      expiredGoldenPoints: 0,
      free_wash_quantity: 0,
      free_wash_amount: 0,
      edit_order: false,
      goldenpointDetails: "",
      goldenPointsLoaded:false,
      showGoldenDetails: false,
      useGoldenPoints: false,
      shouldUseGoldenPoints: false,
      isApplyingGoldenPoints: false,
      is_golden_bonus_used: false,
      qitaf_otp_time: false,
      not_applicable: false,
      original_total: "",
      applicable_sub_total: "",
      original_tax: "",
      customPaymentAmount: "",
      skipRedeemPoints: false,
      isInternalTabChange: false,
      remainBalance: 0,
      latestAppliedDiscount: 0,
      free_wash_discount: "",
      paymentMathod: "",
      successMessage: "",
      loading: false,
      isRemainingBalanceLoading: false,
      isPayButtonClicked: false,
      lateDeliveryConfigs: [],
      selectedLateDeliveryConfig: null,
      goldenPointList: [],
      order: null as IOrder | null,
      originalOrder: null as IOrder | null,
      paymentSource: null,
      walletVerifyOpen: false,
      walletVerifyChannel: null,
      walletVerifyOtpCode: "",
      walletVerifyToken: "",
      walletVerifyMaskedPhone: "",
      walletVerifyExpiresAt: "",
      walletVerifySending: false,
      walletVerifyVerifying: false,
      walletVerifyOtpSent: false,
      walletVerified: false,
      walletVerifyError: "",
      walletVerifyWalletType: "",
      walletVerifyAmount: 0,
      otpAttemptRights: false,
      isButtonDisabled: false,
      selectedSecondPaymentMethodID: 0,
      paymentReferenceRequired: false,
      paymentReferenceModalOpen: false,
      paymentReferenceNumber: "",

      // Customizable Area End
    };
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }

  getRewardsCallId: string = "";
  getWalletBalanceCallId: string = "";
  getRemainBalanceCallId: string = "";
  getPaymentMethodsCallId: string = "";
  redeemAllPointsCallId: string = "";
  makePaymentCallId: string = "";
  applyBonusPointCallId: string = "";
  qitafEarnRewardCallId: string = "";
  sendOtpCallId: string = "";
  sendWalletVerifyOtpCallId: string = "";
  verifyWalletCallId: string = "";
  getLateDeliveryConfigsCallId: string = "";
  getGoldenPointsCallId: string = "";
  getQitafTransactionCallId: string = "";
  getOrderDetailsListsCallId: string = "";
  getOrderDetailsCallId: string = "";
  getGoldenPointsListCallID: string = "";
  makeOtpCallId: string = "";
  getPaymentReferenceCallId: string = "";
  headerContentType = { "Content-Type": "application/json" };

  async getHeaders() {
    const token = await getStorageData("token");
    return {
      "Content-Type": "application/json",
      token,
    };
  }

  getRewards = () => {
    const { customerId } = this.props;

    const message = makeApiMessage({
      method: "GET",
      url: configJSON.getTotalRewardPointsEndpoint + customerId,
    });

    this.getRewardsCallId = message.messageId;
    runEngine.sendMessage(message.id, message);
  };

  getWalletBalance = () => {
    const { customerId } = this.props;

    const message = makeApiMessage({
      url: configJSON.getWalletBalanceEndpoint + customerId,
      method: "GET",
    });

    this.getWalletBalanceCallId = message.messageId;
    runEngine.sendMessage(message.id, message);
  };

    getGoldenPoints = () => {
    const store_management_id = localStorage.getItem("store_id");
    const { order, originalOrder } = this.state;
    const { customerId, fromUnpaid } = this.props;
    const orderId = this.props.order?.id || originalOrder?.id || "";
    // this.setState({ isRemainingBalanceLoading: true });

    const message = makeApiMessage({
      url: `${configJSON.getGoldenPointsEndpoint}${customerId}&store_management_id=${store_management_id}&edit_order=${fromUnpaid ? true : false}&order_id=${orderId}`,
      method: "GET",
    });

    this.getGoldenPointsCallId = message.messageId;
    runEngine.sendMessage(message.id, message);
  };

  // getQitafTransaction = () => {
  //   const store_management_id = localStorage.getItem("store_id");
  //   const { customerId } = this.props;
  //   this.setState({ isRemainingBalanceLoading: true });

  //   const message = makeApiMessage({
  //     url: `${configJSON.getGoldenPointsEndpoint}${customerId}&store_management_id=${store_management_id}`,
  //     method: "GET",
  //   });

  //   this.getQitafTransactionCallId = message.messageId;
  //   runEngine.sendMessage(message.id, message);
  // };

  getOrderDetails = () => {
    const store_management_id = localStorage.getItem("store_id");
    const { customerId } = this.props;
    const message = makeApiMessage({
      url: `${configJSON.getOrderDetailsApi}/${this.props.order?.id || 0}`,
      method: "GET",
    });
    this.getOrderDetailsCallId = message.messageId;
    runEngine.sendMessage(message.id, message);
  };

  async getLateDeliveryConfigs() {
    const headers = await this.getHeaders();

    const message = makeApiMessage({
      url: configJSON.getLateDeliveryConfigsEndpoint,
      headers: headers,
      method: "GET",
    });

    this.getLateDeliveryConfigsCallId = message.messageId;
    runEngine.sendMessage(message.id, message);
  }

  async getRemainBalance() {
    if (!this.props.order) return;
    this.setState({ isRemainingBalanceLoading: true });
    const { order, cleaningOrder } = this.props;

    const headers = await this.getHeaders();
    const isEditKey = this.props.fromUnpaid ? "&edit_order=true" : "";
    const cleaningOrderKeys = cleaningOrder ? "&unpaid_amount=true" : "";

    const endpoint = cleaningOrder
      ? configJSON.getRemainingBalanceEndPointForCleaningOrder
      : configJSON.getRemainingBalanceEndPoint;

    const message = makeApiMessage({
      url: endpoint + order?.id + isEditKey + cleaningOrderKeys,
      headers: headers,
      method: "GET",
    });

    this.getRemainBalanceCallId = message.messageId;
    runEngine.sendMessage(message.id, message);
  }


// async sendOtp(isQitaf: boolean, isMokafaa: boolean) {
//   const apiUrl = configJSON.verifyOtpApi;

//   const payload: any = {
//     id: this.props?.order?.id || 0,
//      active_tab: this.state.activeTab
//   };

//   if (isQitaf) {
//     payload.is_qitaf = true;
//   }

//   if (isMokafaa) {
//     payload.is_mokkafa = true;
//   }

//   const headers = await this.getHeaders();

//   const message = makeApiMessage({
//     body: JSON.stringify(payload),
//     headers: headers,
//     method: "POST",
//     url: apiUrl,
//   });

//   this.sendOtpCallId = message.messageId;
//   runEngine.sendMessage(message.id, message);
// }

  async sendOtp(isQitaf: boolean, isMokafaa: boolean) {
    const apiUrl = configJSON.verifyOtpApi;

    const {
      activeTab,
      secondPaymentEnabled,
      selectedSecondPaymentMethodID,
    } = this.state;

    const paymentMethodIds: number[] = [Number(activeTab)];
    if (
      secondPaymentEnabled &&
      selectedSecondPaymentMethodID &&
      !paymentMethodIds.includes(Number(selectedSecondPaymentMethodID))
    ) {
      paymentMethodIds.push(Number(selectedSecondPaymentMethodID));
    }

    const payload: any = {
      id: this.props?.order?.id || 0,
      payment_method_ids: paymentMethodIds,
    };
    if (isQitaf) {
      payload.is_qitaf = true;
    }
    if (isMokafaa) {
      payload.is_mokkafa = true;
    }

    const headers = await this.getHeaders();

    const message = makeApiMessage({
      body: JSON.stringify(payload),
      headers,
      method: "POST",
      url: apiUrl,
    });

    this.sendOtpCallId = message.messageId;
    runEngine.sendMessage(message.id, message);
  }

  getWalletVerificationParams = (): { wallet_type: string; amount: number } | null => {
    const {
      paymentSource,
      shouldUseGoldenPoints,
      customPaymentAmount,
      walletBalance,
      goldenpointApplicableBalance,
      remainBalance,
    } = this.state;

    const remain = Number(remainBalance) || 0;
    const custom = Number(customPaymentAmount) || 0;

    if (paymentSource === "wallet") {
      const wallet = Number(walletBalance) || 0;
      const desired = custom > 0 ? custom : wallet;
      const amount = Math.min(desired, wallet, remain);
      if (amount <= 0) return null;
      return { wallet_type: "regular", amount: Number(amount.toFixed(2)) };
    }

    if (shouldUseGoldenPoints || paymentSource === "golden") {
      const golden = Number(goldenpointApplicableBalance) || 0;
      const desired = custom > 0 ? custom : golden;
      const amount = Math.min(desired, golden, remain);
      // if (amount <= 0) return null;
      return { wallet_type: "golden_point", amount: Number(amount.toFixed(2)) };
    }

    if (paymentSource === "compensation") {
      const amount = Math.min(custom > 0 ? custom : remain, remain);
      if (amount <= 0) return null;
      return { wallet_type: "compensation", amount: Number(amount.toFixed(2)) };
    }

    return null;
  };

  requiresWalletVerification = (): boolean => {
    return this.getWalletVerificationParams() !== null;
  };

  openWalletVerification = () => {
    const params = this.getWalletVerificationParams();
    if (!params) return;
    this.setState({
      walletVerifyOpen: true,
      walletVerifyChannel: null,
      walletVerifyOtpCode: "",
      walletVerifyToken: "",
      walletVerifyMaskedPhone: "",
      walletVerifyExpiresAt: "",
      walletVerifyOtpSent: false,
      walletVerifyError: "",
      walletVerifyWalletType: params.wallet_type,
      walletVerifyAmount: params.amount,
      walletVerified: false,
      loading: false,
      isPayButtonClicked: false,
    });
    if (!this.resolveCustomerPhone() && this.props.order?.id) {
      this.getOrderDetails();
    }
  };

  closeWalletVerification = () => {
    this.setState({
      walletVerifyOpen: false,
      walletVerifyChannel: null,
      walletVerifyOtpCode: "",
      walletVerifyToken: "",
      walletVerifySending: false,
      walletVerifyVerifying: false,
      walletVerifyOtpSent: false,
      walletVerifyError: "",
    });
  };

  selectWalletVerifyChannel = (channel: "qr" | "otp") => {
    this.setState({
      walletVerifyChannel: channel,
      walletVerifyOtpCode: "",
      walletVerifyToken: "",
      walletVerifyOtpSent: false,
      walletVerifyError: "",
    });
  };

  setWalletVerifyOtpCode = (otp: string) => {
    const cleaned = otp.replace(/\D/g, "").slice(0, 4);
    this.setState({ walletVerifyOtpCode: cleaned, walletVerifyError: "" });
  };

  setWalletVerifyToken = (token: string) => {
    this.setState({ walletVerifyToken: token, walletVerifyError: "" });
  };

  resolveCustomerPhone = (): string => {
    const propsOrder: any = this.props.order || {};
    const stateOrder: any = this.state.order || {};
    const originalOrder: any = this.state.originalOrder || {};
    const candidates = [
      propsOrder?.customer?.full_phone_number,
      propsOrder?.customer?.phone_number,
      stateOrder?.customer?.full_phone_number,
      stateOrder?.customer?.phone_number,
      originalOrder?.customer?.full_phone_number,
      originalOrder?.customer?.phone_number,
      propsOrder?.attributes?.customer?.full_phone_number,
      propsOrder?.customer_phone,
      propsOrder?.customer_full_phone_number,
    ];
    const found = candidates.find(
      (value) => typeof value === "string" && value.length > 0
    );
    return found ? String(found) : "";
  };

  async sendWalletVerifyOtp() {
    const orderId = this.props.order?.id || this.state.order?.id;
    const phone = this.resolveCustomerPhone();
    const walletType = this.state.walletVerifyWalletType;
    const amount = this.state.walletVerifyAmount;

    if (!orderId) {
      this.setState({ walletVerifyError: "Missing order id." });
      return;
    }

    const allowZeroAmount = this.state.paymentSource === "golden" || this.state.shouldUseGoldenPoints;

    if (!walletType || (!allowZeroAmount && !(amount > 0))) {
      this.setState({ walletVerifyError: "Missing wallet info." });
      return;
    }
    if (!phone) {
      this.setState({
        walletVerifyError:
          "Customer phone number not available. Reopen the order or refresh.",
      });
      this.getOrderDetails();
      return;
    }

    const normalizedPhone = String(phone).startsWith("+")
      ? String(phone)
      : `+${phone}`;

    this.setState({ walletVerifySending: true, walletVerifyError: "" });

    const headers = await this.getHeaders();
    const message = makeApiMessage({
      method: "POST",
      url: configJSON.walletVerificationOtpEndpoint,
      headers: headers,
      body: JSON.stringify({
        phone_number: normalizedPhone,
        order_id: orderId,
        wallet_type: walletType,
        amount: amount,
      }),
    });

    this.sendWalletVerifyOtpCallId = message.messageId;
    runEngine.sendMessage(message.id, message);
  }

  async verifyWallet() {
    const { walletVerifyChannel, walletVerifyOtpCode, walletVerifyToken } =
      this.state;
    const order = this.props.order;

    let body: { token?: string; phone_number?: string; otp_code?: string };
    if (walletVerifyChannel === "qr") {
      if (!walletVerifyToken.trim()) {
        this.setState({ walletVerifyError: "Please enter the QR token." });
        return;
      }
      body = { token: walletVerifyToken.trim() };
    } else if (walletVerifyChannel === "otp") {
      if (walletVerifyOtpCode.length !== 4) {
        this.setState({ walletVerifyError: "Enter the 4-digit OTP." });
        return;
      }
      const phone = this.resolveCustomerPhone();
      if (!phone) {
        this.setState({ walletVerifyError: "Missing customer phone." });
        return;
      }
      const normalizedPhone = String(phone).startsWith("+")
        ? String(phone)
        : `+${phone}`;
      body = { phone_number: normalizedPhone, otp_code: walletVerifyOtpCode };
    } else {
      return;
    }

    this.setState({ walletVerifyVerifying: true, walletVerifyError: "" });

    const headers = await this.getHeaders();
    const message = makeApiMessage({
      method: "POST",
      url: configJSON.walletVerificationVerifyEndpoint,
      headers: headers,
      body: JSON.stringify(body),
    });

    this.verifyWalletCallId = message.messageId;
    runEngine.sendMessage(message.id, message);
  }

  receiveSendWalletVerifyOtp = (responseJson: any) => {
    if (responseJson?.data?.verification_id) {
      this.setState({
        walletVerifySending: false,
        walletVerifyOtpSent: true,
        walletVerifyMaskedPhone: responseJson.data.masked_phone_number || "",
        walletVerifyExpiresAt: responseJson.data.expires_at || "",
        walletVerifyError: "",
      });
    } else {
      const errorMessage =
        responseJson?.errors?.[0] ||
        responseJson?.error ||
        responseJson?.message ||
        "Failed to send OTP.";
      this.setState({
        walletVerifySending: false,
        walletVerifyError:
          typeof errorMessage === "string"
            ? errorMessage
            : "Failed to send OTP.",
      });
    }
  };

  receiveVerifyWallet = (responseJson: any) => {
    if (responseJson?.meta?.verified) {
      this.setState(
        {
          walletVerifyVerifying: false,
          walletVerified: true,
          walletVerifyOpen: false,
          walletVerifyChannel: null,
          walletVerifyOtpCode: "",
          walletVerifyToken: "",
          walletVerifyOtpSent: false,
          walletVerifyError: "",
          loading: true,
          isPayButtonClicked: true,
        },
        () => {
          this.makePayment("", {});
        }
      );
    } else {
      const errorMessage =
        responseJson?.errors?.[0] ||
        responseJson?.error ||
        responseJson?.message ||
        "Invalid or expired verification.";
      this.setState({
        walletVerifyVerifying: false,
        walletVerifyError:
          typeof errorMessage === "string"
            ? errorMessage
            : "Invalid or expired verification.",
      });
    }
  };

  async getPaymentMethods() {
    const headers = await this.getHeaders();

    const message = makeApiMessage({
      url: configJSON.paymentMethodsEndpoint,
      headers: JSON.stringify(headers),
      method: "GET",
    });

    this.getPaymentMethodsCallId = message.messageId;
    runEngine.sendMessage(message.id, message);
  }

  async redeemAllPoints() {
    const { customerId } = this.props;
    const { points, remainBalance } = this.state;

    const headers = await this.getHeaders();
    const message = makeApiMessage({
      method: "PUT",
      url: configJSON.getRedeemPointsEndpoint + customerId,
      headers: headers,
      body: JSON.stringify({
        points: points,
        order_total: remainBalance,
      }),
    });

    this.redeemAllPointsCallId = message.messageId;

    runEngine.sendMessage(message.id, message);
  }

  async makePayment(otp: string, orders?: any) {
      const currentOrder = this.props?.order || orders;
    if (!currentOrder) return;
    if (
      !this.state.paymentMethods.some(
        (paymentMethod: IPaymentMethod) => 
          paymentMethod.id === this.state.activeTab
      )
    )
      return;

    this.setState({ isPayButtonClicked: true });
    // const { order, fromUnpaid, customerId, cleaningOrder } = this.props || {};
    const {fromUnpaid, customerId, cleaningOrder } = this.props || {};
    const order = currentOrder;

    const {
      activeTab,
      remainBalance,
      customPaymentAmount,
      secondPaymentEnabled,
      selectedLateDeliveryConfig,
      lateDeliveryConfigs,
      goldenpointBalance,
      goldenpointApplicableBalance,
      expiredGoldenPoints,
      useGoldenPoints,
      selectedSecondPaymentMethodID
    } = this.state;

    const payLaterId = this.getPaymentMethodId("Pay Later");
    const secondaryPaymentId = this.getSecondaryPaymentMethod()?.id;

    const isPayLater = payLaterId === activeTab;
    const isQuickDrop = Boolean(order?.is_quick_drop);
    const extraFields = fromUnpaid ? { edit_order: true } : {};

    const isWalletSelected = this.state.paymentSource === "wallet";
    const isGoldenPointSelected = this.state.shouldUseGoldenPoints === true;

    const paymentMethodName =
      this.state.paymentMethods.find(
        (paymentMethod: IPaymentMethod) =>
          paymentMethod.id === this.state.activeTab
      )?.name;

    let primarySource = "";
    let primaryAmountUsed = 0;
    let walletDeductAmount = "";
    let totalPaidFromWalletAndPoints = 0;
    let gpToUse = goldenpointApplicableBalance;
    if (gpToUse > remainBalance) gpToUse = remainBalance;
    totalPaidFromWalletAndPoints += gpToUse;
    if (totalPaidFromWalletAndPoints < remainBalance) {
      // let walletToUse = this.state.walletBalance
      let walletToUse = Number(this.state.walletBalance || 0) - Number(this.state.customPaymentAmount || 0);
      if (walletToUse > remainBalance - totalPaidFromWalletAndPoints) {
        walletToUse = remainBalance - totalPaidFromWalletAndPoints;
      }
      totalPaidFromWalletAndPoints += walletToUse;
      walletDeductAmount = walletToUse.toFixed(2);
    }

    primaryAmountUsed = Number(customPaymentAmount);
    if (isWalletSelected) {
      primarySource = "Wallet";
      const remain = Number(remainBalance ?? 0);
      const custom = Number(customPaymentAmount ?? 0);
      let walletDeductAmount = Math.max(remain - custom, 0);
      primaryAmountUsed = Math.min(
        Number(customPaymentAmount || this.state.walletBalance),
        Number(this.state.walletBalance),
        Number(remainBalance)
      );
    }

      const isGoldenBonusUsed = this.props?.order?.discount_summary?.is_golden_bonus_used || false;
      const appliedDiscount = isGoldenBonusUsed ? Number(this.latestAppliedDiscount || 0) : 0;
    if (isGoldenPointSelected) {
      primarySource = "Golden Points";
      const customAmount = Number(customPaymentAmount ?? 0);
      const goldenBalance = Number(goldenpointApplicableBalance || 0);
      const remain = Number(remainBalance || 0);
      // const usableGoldenBalance = Math.max(goldenBalance - appliedDiscount, 0);
      const usableGoldenBalance = Math.max(goldenBalance , 0);

      primaryAmountUsed = Math.min(
        customAmount > 0 ? customAmount : usableGoldenBalance,
        usableGoldenBalance,
        remain
      );
      //  primaryAmountUsed = Math.min(
      //   Number(customPaymentAmount || goldenpointApplicableBalance),
      //   Number(goldenpointApplicableBalance),
      //   Number(remainBalance)
      // );
    }
    // amountLeftForSecondPayment = Math.max(
    //   Number(remainBalance) - Number(primaryAmountUsed),
    //   0
    // );
    let amount;
    if (activeTab === 5) {
      amount = Number(primaryAmountUsed.toFixed(2));
    } else if (!isPayLater) {
      amount = Number(customPaymentAmount);
    } else if (isQuickDrop) {
      amount = 0;
    } else {
      amount = Number(order?.total);
    }
    let paymentBody;
    // let finalAmount: number;
    // const primary = Number(primaryAmountUsed);
    // const remain = Number(remainBalance);
    //    const golden =
    //   Number(goldenpointApplicableBalance) - (appliedDiscount);
    
    // if (primary === golden) {
    //   finalAmount = primary;
    // } else if (Number(this.latestAppliedDiscount) > primary) {
    //   finalAmount = primary;
    // } else if (primary === remain) {
    //   finalAmount = primary;
    // } else {
    //   finalAmount =(primary - Number(this.latestAppliedDiscount));
    // }
    // finalAmount = Math.round(finalAmount * 100) / 100;
    // if (finalAmount < 0) {
    //   finalAmount = 0;
    // }
    let finalAmount: number;
    const primary = Number(primaryAmountUsed);
    const remain = Number(remainBalance);
    // const golden = Number(goldenpointApplicableBalance) - Number(appliedDiscount || 0);
    const golden = Number(goldenpointApplicableBalance) 
    if (isGoldenPointSelected && remain <= golden) {
      finalAmount = remain; 
    } else {
      if (primary === golden) {
        finalAmount = primary;
      } else if (Number(this.latestAppliedDiscount) > primary) {
        finalAmount = primary;
      } else if (primary === remain) {
        finalAmount = primary;
      } else {
        finalAmount = primary - Number(this.latestAppliedDiscount || 0);
      }
    }
    finalAmount = Math.round(finalAmount * 100) / 100;
    if (finalAmount < 0) {
      finalAmount = 0;
    }
    let amountLeftForSecondPayment = Math.max(
      Number(remainBalance) - Number(primaryAmountUsed),
      0
    );
    amountLeftForSecondPayment =
      Math.round(amountLeftForSecondPayment * 100) / 100;
      if (activeTab === 5 && Number(primaryAmountUsed) < Number(remainBalance)) {
         const isGoldenBonusUsed = this.props?.order?.discount_summary?.is_golden_bonus_used || false;
         const discount = isGoldenBonusUsed ? Number(this.latestAppliedDiscount || 0) : 0;
        let baseBalance;
        if (primary === golden) {
          baseBalance = Number(remainBalance);
        } else {
          baseBalance =
            discount > 0
              ? Number(discount) + Number(remainBalance)
              : Number(remainBalance);
        }
        //  const  amountLeftForSecondPayment = Math.max(
      if (secondPaymentEnabled &&  discount > 0) {
              amountLeftForSecondPayment = Math.max(
                baseBalance - Number(primaryAmountUsed)-discount,
                0
              );
      } else {
        amountLeftForSecondPayment = Math.max(
                  baseBalance - Number(primaryAmountUsed),
                  0
                );
      }
        amountLeftForSecondPayment =
      Math.round(amountLeftForSecondPayment * 100) / 100;
      }
    if (
      isGoldenPointSelected &&
      this.latestAppliedDiscount > 0 &&
      remainBalance > goldenpointApplicableBalance
    ) {
      paymentBody = [
        {
          // amount:
          //   Math.round((primaryAmountUsed - this.latestAppliedDiscount) * 100) /
          //   100,
          amount: finalAmount,
          account_id: customerId,
          // payment_method_id: activeTab,
          payment_method_id: 5,
        },
      ];
    } else {
      // paymentBody = [
      //   {
      //     amount: Math.round(primaryAmountUsed * 100) / 100,
      //     account_id: customerId,
      //     // payment_method_id: activeTab,
      //     payment_method_id: isGoldenPointSelected ? 5 : activeTab, 
      //   },
      // ];
       paymentBody = [
          {
            amount: Math.round(primaryAmountUsed * 100) / 100,
            account_id: customerId,
            payment_method_id:
              isGoldenPointSelected && this.latestAppliedDiscount > 0
                ? 5
                : activeTab,
          },
        ];
    }
    if (amountLeftForSecondPayment <= 0 && secondPaymentEnabled) {
      amountLeftForSecondPayment = Number(customPaymentAmount);
    }
    if (
      activeTab !== 5 &&
      (this.state.paymentSource === "golden" ||
        this.state.paymentSource === "wallet")
    ) {
      this.setState({
        secondPaymentEnabled: true,
      });
    }
      let finalSecondPaymentAmount = remain - primary;
      finalSecondPaymentAmount =
        Math.round(finalSecondPaymentAmount * 100) / 100;
      const isDifferent =
        Math.abs(finalSecondPaymentAmount - Number(amountLeftForSecondPayment || 0)) > 0.01;
      
      if (isWalletSelected && isDifferent && secondPaymentEnabled) {
        const discount = this.props?.order?.discount_summary?.is_golden_bonus_used ? Number(order?.applied_discount || 0) : 0;
        amountLeftForSecondPayment = 
          amountLeftForSecondPayment - discount - primaryAmountUsed
      }
    if (secondPaymentEnabled && amountLeftForSecondPayment > 0) {
      paymentBody.push({
        // amount: Number(amountLeftForSecondPayment.toFixed(2)),
        amount: Math.round(amountLeftForSecondPayment * 100) / 100,
        account_id: customerId,
        // payment_method_id: Number(secondaryPaymentId),
        payment_method_id: Number(selectedSecondPaymentMethodID)
      });
    }

    const isSecondPayment = paymentBody.length > 1;
    // const isSecondPayment = secondPaymentEnabled;
    const transKey = cleaningOrder
      ? "home_cleaning_order_transactions_attributes"
      : "order_transactions_attributes";

    const selectedConfig = lateDeliveryConfigs.find(
      (config) => config.id === selectedLateDeliveryConfig
    );
    const lateDeliveryParams = selectedConfig
      ? {
          isLateDelivery: "true",
          lateDeliveryHours: selectedConfig.attributes.hours,
          color_code: selectedConfig.attributes.color,
        }
      : {
          isLateDelivery: "false",
        };

    const headers = await this.getHeaders();

    const propOrderAny = this.props.order as any;
    const stateOrderAny = this.state.order as any;
    let mobileRequestId =
      stateOrderAny?.mobile_service_request_id ??
      stateOrderAny?.mobile_request_id ??
      stateOrderAny?.mobile_service_request?.id ??
      propOrderAny?.mobile_service_request_id ??
      propOrderAny?.mobile_request_id ??
      propOrderAny?.mobile_service_request?.id;
    if (!mobileRequestId) {
      try {
        const stored = window.localStorage.getItem("mobileServiceRequestData");
        if (stored) {
          const parsed = JSON.parse(stored);
          mobileRequestId = parsed?.mobile_service_request_id ?? parsed?.mobile_request_id;
        }
      } catch (e) {
        // ignore
      }
    }
    const walletGoldenPoints =
      activeTab === 5 && this.state.useGoldenPoints;
    const jsonBody = JSON.stringify({
      ...extraFields,
      id: currentOrder.id || 0,
      [transKey]: paymentBody.filter((item) => item.amount >= 0),
      second_payment: isSecondPayment,
      ...lateDeliveryParams,
      // ...(this.state.shouldUseGoldenPoints || useGoldenPoints
      //   ? { use_golden_points: true }
      //   : { use_golden_points: false }),
          use_golden_points: walletGoldenPoints,
      ...(Number(walletDeductAmount) > 0 && {
        wallet_deduct_amount: Number(walletDeductAmount),
      }),
      ...(mobileRequestId ? { mobile_request_id: mobileRequestId } : {}),
      ...(paymentMethodName === "Mokafaa"
          ? { mokkafa_otp: otp || "" }
          : { otp: otp || "" }),
      // ...(activeTab === 8
      //   ? { mokkafa_otp: otp || "" }
      //   : { otp: otp || "" }),
      ...(this.state.paymentReferenceRequired && this.isCreditCardPayment()
        ? { payment_reference: this.state.paymentReferenceNumber.trim() }
        : {}),
    } as {});

    const message = makeApiMessage({
      method: "PUT",
      body: jsonBody,
      headers: headers,
      url: cleaningOrder
        ? configJSON.addPaymentTransactionHomeCleaningEndPoint
        : configJSON.addPaymentTransactionEndPoint,
    });

    this.makePaymentCallId = message.messageId;
    runEngine.sendMessage(message.id, message);
  }


  getSecondaryPaymentMethod() {
    const { selectedSecondPaymentMethod, paymentMethods } = this.state;
    return paymentMethods.find(
      (item: IPaymentMethod) => item.name === selectedSecondPaymentMethod
    );
  }

  getPrimaryPaymentMethod() {
    const { activeTab, paymentMethods } = this.state;
    return paymentMethods.find(
      (paymentMethod) => paymentMethod.id === activeTab
    );
  }

  getPaymentMethodId(keyName: string) {
    const cashPayment = this.state.paymentMethods.find(
      (paymentMethod) => paymentMethod.name.toLowerCase() === keyName
    );
    return cashPayment ? cashPayment.id : 0;
  }

  getCashPaymentId = () => {
    const cashPayment = this.state.paymentMethods.find(
      (paymentMethod) => paymentMethod.name.toLowerCase().trim() === "cash"
    );
    return cashPayment ? cashPayment.id : 0;
  };

  getPayLaterPaymentId = () => {
    const payment = this.state.paymentMethods.find(
      (paymentMethod) => paymentMethod.name.toLowerCase().trim() === "pay later"
    );
    return payment ? payment.id : 0;
  };

  getWalletPaymentId = () => {
    const cashPayment = this.state.paymentMethods.find((paymentMethod) => {
      return paymentMethod?.name?.toLowerCase().trim() === "wallet";
    });
    return cashPayment ? cashPayment.id : 0;
  };

  async componentDidMount() {
    this.handleGetPaymentMethods();
    this.getRemainBalance();
    this.getWalletBalance();
    if (this.props.fromUnpaid !== true) {
      this.getGoldenPoints();
    }
    this.getRemainBalance();
    this.getRewards();
    this.getLateDeliveryConfigs();
    this.getGoldenPointsList();
    this.getPaymentReference();
    // this.getQitafTransaction();
  }

  getPaymentReference = () => {
    const storeId = localStorage.getItem("store_id");
    if (!storeId) return;
    const message = makeApiMessage({
      url: `${configJSON.getPaymentReferenceEndpoint}${storeId}/payment_reference`,
      method: "GET",
    });
    this.getPaymentReferenceCallId = message.messageId;
    runEngine.sendMessage(message.id, message);
  };

  receivePaymentReference = (responseJson: { payment_reference?: boolean }) => {
    this.setState({
      paymentReferenceRequired: !!responseJson?.payment_reference,
    });
  };

  isCreditCardPayment = () => {
    const primary = this.getPrimaryPaymentMethod();
    const secondary = this.getSecondaryPaymentMethod();
    const isCreditCard = (paymentMethod?: IPaymentMethod) =>
      paymentMethod?.name?.toLowerCase().trim() === "credit card";
    return isCreditCard(primary) || isCreditCard(secondary);
  };

  openPaymentReferenceModal = () => {
    this.setState({
      paymentReferenceModalOpen: true,
      paymentReferenceNumber: "",
    });
  };

  closePaymentReferenceModal = () => {
    this.setState({
      paymentReferenceModalOpen: false,
      paymentReferenceNumber: "",
      loading: false,
    });
  };

  setPaymentReferenceNumber = (value: string) => {
    this.setState({ paymentReferenceNumber: value });
  };

  submitPaymentReference = () => {
    if (!this.state.paymentReferenceNumber.trim()) {
      this.setState({
        errorMessage: "Please enter reference number",
        errorSnackbarOpen: true,
      });
      return;
    }
    this.setState({ paymentReferenceModalOpen: false });
    this.makePayment("", {});
  };

  applyGoldenPoints = (usePoints: boolean) => {
    if (this.props.fromUnpaid) {
      usePoints = false;
    }
    if (!this.props?.order?.id) return;
    this.setState({
      isApplyingGoldenPoints: true,
      is_golden_bonus_used: usePoints,
    });
    const jsonBody = {
      order_id: this.props.order.id,
      use_golden_points: usePoints,
    };
    const message = makeApiMessage({
      method: "PUT",
      body: JSON.stringify(jsonBody),
      headers: { "Content-Type": "application/json" },
      url: configJSON.applyGoldenBonusPoint,
    });

    this.applyBonusPointCallId = message.messageId;
    runEngine.sendMessage(message.id, message);
  };

  handleGetPaymentMethods = () => {
    let data = localStorage.getItem("payment_method_lists");

    if (data) {
      this.setState({ paymentMethods: JSON.parse(data) }, () =>
        this.handleAfterPaymentMethod()
      );
    } else {
      this.getPaymentMethods();
    }
  };

  handlePayAll = () => {
    if (this.state.activeTab === this.getWalletPaymentId()) {
      const walletBalance =
        Number(this.state.walletBalance) +
        Number(this.state.goldenpointApplicableBalance);
      if (
        walletBalance < this.state.remainBalance &&
        !this.state.secondPaymentEnabled
      ) {
        this.setState({
          errorMessage: configJSON.label_notSufficientWalletBalance,
          errorSnackbarOpen: true,
        });
        return;
      }
    }
    this.setState({
      customPaymentAmount: this.state.remainBalance + "",
    });
  };

  checkForBalance = (prevProps: Props) => {
    if (
      this.props.order !== prevProps.order &&
      this.props.order &&
      this.props.order.id &&
      this.props.open
    ) {
      this.getRemainBalance();
      if (
        this.props.order.applied_discount !==
          prevProps.order?.applied_discount ||
        this.props.order.promo_code_id !== prevProps.order?.promo_code_id
      ) {
        this.setState((prevState) => ({
          order: {
            ...prevState.order!,
            applied_discount: this.props.order!.applied_discount,
            discount_summary: this.props.order!.discount_summary,
            sub_total: this.props.order!.sub_total,
            total: this.props.order!.total,
            total_tax: this.props.order!.total_tax,
            taxable_amount: this.props.order!.taxable_amount,
            promo_code_id: this.props.order!.promo_code_id,
             qitaf_otp_time: this.props.order!.qitaf_otp_time,
          },
        }));
      }
    }
  };

  checkForTabChange = (prevProps: Props, prevState: S) => {
    const { activeTab } = this.state;
    if (activeTab !== prevState.activeTab) {
      this.setState({
        showOtpScreen: false,
        customPaymentAmount: this.state.remainBalance + "",
      });
    }
  };

  async componentDidUpdate(prevProps: Props, prevState: S) {
    const {
      remainBalance,
      walletBalance,
      goldenpointBalance,
      customPaymentAmount,
      goldenpointApplicableBalance,
      expiredGoldenPoints,
      activeTab,
      useGoldenPoints,
    } = this.state;

    const remainNum = parseFloat(remainBalance as any) || 0;
    const walletNum = parseFloat(walletBalance as any) || 0;
    const goldenNum = parseFloat(goldenpointApplicableBalance as any) || 0;
    const goldenExpiredNum = parseFloat(expiredGoldenPoints as any) || 0;
    const inputAmount = parseFloat(customPaymentAmount as any) || 0;

    const isWalletTab = activeTab === this.getWalletPaymentId();
    let usable_gp: number = 0;

    let newSecondPaymentEnabled = prevState.secondPaymentEnabled;

     const isGoldenBonusUsed = !!this.state?.order?.discount_summary?.is_golden_bonus_used;
     const appliedDiscount = isGoldenBonusUsed ? Number(this.state.order?.applied_discount ?? 0) : 0;
    // if (isWalletTab && inputAmount > 0) {
    if (
      Number(inputAmount) > 0 &&
      (this.state.paymentSource === "wallet" || isWalletTab)
    ) {
      const walletSafe = Math.max(walletNum, 0);
      const goldenSafe = Math.max(goldenNum, 0);
      const remainSafe = Math.max(remainNum, 0);
      const goldenExpiredSafe = Math.max(goldenExpiredNum, 0);
      const totalAvailable = walletSafe + goldenSafe;
      const usableGP = goldenSafe - goldenExpiredSafe;
      const combinedInsufficient = remainSafe > totalAvailable;
      newSecondPaymentEnabled =
        combinedInsufficient ||
        (usableGP === 0 &&
          walletSafe < remainSafe &&
          inputAmount <= remainSafe);
      //       if (!useGoldenPoints) {
      //         newSecondPaymentEnabled =
      //           newSecondPaymentEnabled || inputAmount < remainBalance;
      //       }
      //       if (this.state.paymentSource === "wallet") {
      //         newSecondPaymentEnabled = walletSafe < remainSafe;
      //       }
      //       if (this.state.paymentSource === "golden") {
      //         newSecondPaymentEnabled = usableGP < remainSafe;
      //       }
      if (!useGoldenPoints && inputAmount < remainBalance) {
        newSecondPaymentEnabled = true;
      }
      if (
        (this.state.paymentSource === "wallet" && walletSafe < remainSafe) ||
        inputAmount < remainBalance
      ) {
        newSecondPaymentEnabled = true;
      }

      if (
        this.state.paymentSource === "golden" ||
        this.state.shouldUseGoldenPoints
      ) {
        if (appliedDiscount > 0) {
              usable_gp = Number(
                (usableGP - appliedDiscount).toFixed(2));
          // usable_gp =
          //   usableGP - Number(this.state.order?.applied_discount ?? 0);

          newSecondPaymentEnabled =
            usable_gp < remainSafe || inputAmount < remainBalance;
          // usableGP < remainSafe || inputAmount < remainBalance;
        } else {
          newSecondPaymentEnabled =
            usableGP < remainSafe || inputAmount < remainBalance;
        }
      }
    } else if (!isWalletTab) {
      newSecondPaymentEnabled = inputAmount < remainNum;
    }
    if (!newSecondPaymentEnabled) {
      newSecondPaymentEnabled =
        activeTab !== 5 &&
        (this.state.paymentSource === "golden" ||
          this.state.paymentSource === "wallet");
    }
    const latestDiscount = Number(this.state.order?.applied_discount ?? 0);
    const totalAvailable = walletNum + goldenNum;
    if (  useGoldenPoints && goldenNum - appliedDiscount >= remainNum &&inputAmount ==remainNum) {
      newSecondPaymentEnabled = false;
    }
    // if (newSecondPaymentEnabled !== prevState.secondPaymentEnabled) {
    //   this.setState({ secondPaymentEnabled: newSecondPaymentEnabled });
    // }
      if (newSecondPaymentEnabled !== this.state.secondPaymentEnabled) {
      this.setState({ secondPaymentEnabled: newSecondPaymentEnabled });
    }
    if (
      prevProps.customerId !== this.props.customerId &&
      Number(this.props.customerId) &&
      this.props.open
    ) {
      this.getRewards();
      this.setState({
        isRedeemAllPoints: false,
        isUsed: false,
      });
    }
    if (
      this.props.order &&
      this.props.open !== prevProps.open &&
      this.props.open
    ) {
      this.getRemainBalance();
      this.setState({
        activeTab: this.props.order.is_quick_drop
          ? this.getPayLaterPaymentId()
          : this.getCashPaymentId(),
        showOtpScreen: false,
        skipRedeemPoints: false,
      });
      if (!this.state.order  && this.props.fromUnpaid!==true) {
        this.getOrderDetails();
      }
    }
    // if (prevState.activeTab !== activeTab) {
    //   this.getOrderDetails();
    // }
    if (prevState.activeTab !== activeTab) {
  if (!this.state.isInternalTabChange) {
    this.getOrderDetails();
  } else {
    // reset flag after internal change
    this.setState({ isInternalTabChange: false });
  }
}

  if ( this.props.fromUnpaid === true && prevState.originalOrder !== this.state.originalOrder && this.state.originalOrder && !this.state.goldenPointsLoaded ) {
    this.getGoldenPoints();
    this.setState({ goldenPointsLoaded: true });

  }
  this.checkForTabChange(prevProps, prevState);
    this.checkForBalance(prevProps);
  }

  useAmount = () => {
    this.setState({
      isUsed: true,
    });
  };

  onOtpSuccess = () => {
    this.makePayment("", {})
  };

  togglePaymentSource = (source: "wallet" | "compensation") => {
    this.setState(
      (prevState) => {
        let newSource: "wallet" | "compensation" | null = source;
        if (prevState.paymentSource === source) {
          newSource = null;
        }
        return {
          paymentSource: newSource,
          shouldUseGoldenPoints: false,
          useGoldenPoints: false,
        };
      },
      () => {
        if (!this.state.secondPaymentEnabled) {
          this.applyGoldenPoints(false);
          this.getOrderDetails();
        }
      }
    );
  };
  toggleGoldenPoints = () => {
    this.setState(
      (prevState) => {
        const nextValue = !prevState.shouldUseGoldenPoints;

        if (!nextValue && prevState.originalOrder) {
          return {
            shouldUseGoldenPoints: false,
            useGoldenPoints: false,
            paymentSource: null,
            order: prevState.originalOrder,
            remainBalance: Number(prevState.originalOrder.total),
            customPaymentAmount: prevState.originalOrder.total.toString(),
          };
        }

        return {
          shouldUseGoldenPoints: nextValue,
          useGoldenPoints: nextValue,
          paymentSource: null,
          order: prevState.order,
          remainBalance: prevState.remainBalance,
          customPaymentAmount: prevState.customPaymentAmount,
        };
      },
      () => {
        this.applyGoldenPoints(this.state.shouldUseGoldenPoints);
      }
    );
  };
  handleSecondPaymentToggle = (balance: number) => {
    const total = Number(this.state.order?.total || 0);
    this.setState((prevState) => {
      if (prevState.secondPaymentEnabled) {
        return { secondPaymentEnabled: false };
      }
      return {
        secondPaymentEnabled: balance < total,
      };
    });
  };

  getGoldenPointsList = (customerId?: string) => {
    if (!customerId) return;
    const message = makeApiMessage({
      url: configJSON.getCustomerGoldenPointsListEndpoint + customerId,
      method: "GET",
    });
    this.getGoldenPointsListCallID = message.messageId;
    runEngine.sendMessage(message.id, message);
  };
  handleCustomerGoldenPointList = (responseJson: any) => {
    if (responseJson && responseJson) {
      const customerGoldenPointList = responseJson;
      this.setState({
        goldenPointList: customerGoldenPointList,
      });
    }
  };

  handlePay() {
    const {
      points,
      skipRedeemPoints,
      secondPaymentEnabled,
      selectedSecondPaymentMethod,
      useGoldenPoints,
      remainBalance,
      walletBalance,
      goldenpointApplicableBalance,
      customPaymentAmount
    } = this.state;

    const { name } = (this.getPrimaryPaymentMethod() as IPaymentMethod) || {};
    const { name: secondName } =
      (this.getSecondaryPaymentMethod() as IPaymentMethod) || {};
    if (name === "Wallets") {
      const condition = points > 0 && !skipRedeemPoints;
      if (condition) {
        this.setState({ skipRedeemPoints: true });
      }
    }

    if (secondPaymentEnabled && !selectedSecondPaymentMethod) {
      this.setState({
        errorMessage: "Please select second payment method",
        errorSnackbarOpen: true,
      });
      return;
    }
    const isEditOrder = this.state.edit_order === true ;
    if (this.state.order?.not_applicable && this.state.activeTab && this.latestAppliedDiscount > 0  && isEditOrder == false ){
      this.setState({
        errorMessage: "Cannot use golden points",
        errorSnackbarOpen: true,
      });
      return;

    }
    const wallet_balance =
      Number(walletBalance) + Number(goldenpointApplicableBalance);
    if (
      !secondPaymentEnabled &&
      this.state.activeTab === 5 &&
      wallet_balance < remainBalance &&
      Number(this.state.goldenpointBalance) > 0 &&
      !this.state.shouldUseGoldenPoints
    ) {
      this.setState({
        errorMessage: "Please enable Golden Points to proceed with payment",
        errorSnackbarOpen: true,
      });
      return;
    }
    if (
      !secondPaymentEnabled &&
      this.state.activeTab === 5 &&
      wallet_balance < remainBalance &&
      Number(this.state.walletBalance) > 0
    ) {
      this.setState({
        errorMessage: "Please enable Wallet Points to proceed with payment",
        errorSnackbarOpen: true,
      });
      return;
    }
    const isWalletSelected = this.state.paymentSource === "wallet";
    const isGoldenPointSelected = this.state.shouldUseGoldenPoints === true;
    const goldenBalance = Number(goldenpointApplicableBalance || 0);
    const subtotal = Number(this.state.remainBalance || 0);
    if (isGoldenPointSelected) {
      if (goldenBalance < subtotal) {
        this.setState({
          errorMessage: "Not enough Golden Points to cover this order",
          errorSnackbarOpen: true,
        });
        return;
      }
    }
    if (this.state.activeTab === 5) {

      if (!isWalletSelected && !isGoldenPointSelected) {
        this.setState({
          errorMessage: "Please select Wallet or Golden Points to proceed",
          errorSnackbarOpen: true,
        });
        return;
      }
    }
    const remain = Number(this.state?.remainBalance || 0);
    const customAmount = Number(customPaymentAmount || 0);
    const remainingAfterCustom = Math.max(remain - customAmount, 0);
    if (isWalletSelected) {
      if (walletBalance < remainingAfterCustom) {
        this.setState({
          errorMessage: "Insufficient wallet balance",
          errorSnackbarOpen: true,
        });
        return;
      }
    }
    if (isGoldenPointSelected) {
      if (goldenBalance < remainingAfterCustom) {
        this.setState({
          errorMessage: "Insufficient golden points balance",
          errorSnackbarOpen: true,
        });
        return;
      }
    }

    if (this.requiresWalletVerification() && !this.state.walletVerified) {
      this.openWalletVerification();
      return;
    }

    if (
      this.state.paymentReferenceRequired &&
      this.isCreditCardPayment() &&
      !this.state.paymentReferenceNumber.trim()
    ) {
      this.openPaymentReferenceModal();
      return;
    }

    this.setState({ loading: true });

    if (this.state.walletVerified) {
      this.makePayment("", {});
      return;
    }

    const isQitaf = [name, secondName].includes("Qitaf");
    const isMokafaa = [name, secondName].includes("Mokafaa");
    if ([name, secondName].includes("Wallets")) {
      this.sendOtp(false, false);
    } 
    else if ((isQitaf || isMokafaa) && !this.state.isQitafOtpComplete) {
      this.sendOtp(isQitaf, isMokafaa);
    } 
    else {
      this.makePayment("", {});
    }
  }

  handleSnackbarClose = () => {
    this.setState({
      errorSnackbarOpen: false,
    });
  };

  handleSuccessSnackbarClose = () => {
    this.setState({
      successMessage: "",
    });
  };

  handleOtpError = (message: string) => {
    this.setState({
      errorMessage: message,
      errorSnackbarOpen: true,
    });
  };

  handleClose = () => {
    this.setState({
      showOtpScreen: false,
      selectedSecondPaymentMethod: "",
      paymentReferenceModalOpen: false,
      paymentReferenceNumber: "",
    });
    this.props.handleClose();
  };

  receiveOtpMessage = (responseJson: { message: string; errors: string }) => {
    if (responseJson.message) {
      this.setState({
        showOtpScreen: true,
      });
    } else if (responseJson.errors) {
      this.setState({
        errorSnackbarOpen: true,
        errorMessage: responseJson.errors,
      });
    }
  };

  receivePaymentMethods = (responseJson: { data: IPaymentMethod[] }) => {
    this.setState(
      {
        paymentMethods: responseJson.data,
      },
      () => this.handleAfterPaymentMethod()
    );
  };

  handleOrderResponse = (responseJson: OrderApiResponse) => {
    const order = responseJson?.data?.attributes;
    if (!order) return;
    const { fromUnpaid } = this.props;

        if (fromUnpaid) {
      this.setState({
        originalOrder: order,
        isRemainingBalanceLoading: false,
      });
    } else {
      this.setState({
        order,
        originalOrder: order,
        remainBalance:
          Number(order.applied_discount) > 0 && order.is_golden_bonus_used
            ? Number(order.total) + Number(order.total_tax)
            : Number(order.total),
            customPaymentAmount: order.total.toString(),
            isRemainingBalanceLoading: false,


      });
    }
  }
  handleApplyDiscountResponse = (responseJson: {
    errors: any;
    data: {
      is_golden_bonus_used: any;
      total: number;
      applied_discount: number;
      taxable_amount: string;
      discount_summary?: any;
      free_wash_discount: string;
      total_tax: any;
      not_applicable: any;
      qitaf_otp_time: any;
      original_total: string;
      applicable_sub_total: string;
      original_tax: string; 
    };
  }) => {

    if (responseJson?.errors) { 
      alert(responseJson.errors);
      this.setState({ 
          isRemainingBalanceLoading: false,
          errorMessage: responseJson.errors,
          errorSnackbarOpen: true,
          shouldUseGoldenPoints: false,
          paymentSource: null,
       }); 
      return; }

    const apiData = responseJson?.data;
    
    if (!apiData) return;

    this.setState((prevState) => {
      if (!prevState.order) return null;
      return {
        order: {
          ...prevState.order,
          total: String(apiData.total ?? 0),
          applied_discount: String(apiData.applied_discount ?? 0),
          taxable_amount: String(apiData.taxable_amount ?? 0),
          total_tax: String(apiData.total_tax ?? 0),
          original_total: String(apiData.original_total ?? 0),
          applicable_sub_total: String(apiData.applicable_sub_total ?? 0),
          original_tax: String(apiData.original_tax ?? 0),
          not_applicable: apiData.not_applicable,
          discount_summary: {
            ...prevState.order.discount_summary,
            ...apiData.discount_summary,
            is_golden_bonus_used: Boolean(apiData.is_golden_bonus_used),
            free_wash_discount: apiData.free_wash_discount ?? 0,
          },
          qitaf_otp_time: apiData.qitaf_otp_time,
        },
        remainBalance: apiData.total ?? 0,
        customPaymentAmount: String(apiData.total ?? 0),
        isRemainingBalanceLoading: false,
        latestAppliedDiscount: apiData.applied_discount ?? 0,
        applicable_sub_total: String(apiData.applicable_sub_total ?? 0),
        free_wash_discount: apiData.free_wash_discount ?? 0,
      };
    });
    this.latestAppliedDiscount = Number(apiData.applied_discount || 0);
  };

  handleAfterPaymentMethod = () => {
    if (this.props.order) {
      this.setState({
        activeTab: this.props.order.is_quick_drop
          ? this.getPayLaterPaymentId()
          : this.getCashPaymentId(),
      });
    }
  };

  receiveRewardCall = (responseJson: {
    total_amount: string;
    points: number;
    currency: string;
  }) => {
    if (responseJson) {
      this.setState({
        totalAmount: responseJson.total_amount || "0",
        points: responseJson.points || 0,
        currency: responseJson.currency || "SAR",
      });
    }
  };

  receiveRedeemAllPoints = (responseJson: {
    errors: string;
    wallet_balance: number;
  }) => {
    if (responseJson.errors) {
      this.setState({
        errorMessage: responseJson.errors,
        errorSnackbarOpen: true,
      });
    } else {
      this.setState(
        {
          isRedeemAllPoints: true,
          walletBalance: Math.max(0, Number(responseJson.wallet_balance)),
        },
        this.getRemainBalance
      );
    }
  };

  receiveRemainBalance = (responseJson: {
    payable_balance: number | string;
    default_payment_method_type: string;
  }) => {
    let resData = responseJson.default_payment_method_type;
    let data = localStorage.getItem("payment_method_lists");
    if (data) {
      let paymentMethodList = JSON.parse(data);
      let matchedMethod = paymentMethodList.find(
        (method: any) => method.payment_type === resData
      );

      if (matchedMethod) {
        this.setState({ activeTab: matchedMethod.id });
      }
    }
    this.setState({
      paymentMathod: responseJson?.default_payment_method_type,
      remainBalance: responseJson.payable_balance as number,
      customPaymentAmount: responseJson.payable_balance + "",
      isRemainingBalanceLoading: false,
    });
    if (
      responseJson.payable_balance === 0 &&
      this.props.order &&
      (this.state.activeTab === this.getPayLaterPaymentId()
        ? this.props.order.status === "placed"
        : Number(this.props.order.total))
    )
      this.props.onPaymentDone();
  };

  receiveWalletBalance = (responseJson: {
    balance: string | number;
    loyalty_credit_amount: string | number;
  }) => {
    const previousTransaction =
      this.props.order &&
      this.props.order.order_transactions.find(
        (item) =>
          item.attributes.payment_method.id === this.getWalletPaymentId()
      );
    this.setState({
      // walletBalance:
      //   Number(responseJson.balance) -
      //   (previousTransaction
      //     ? Number(previousTransaction.attributes.amount)
      //     : 0),
      walletBalance: Math.max(0, Number(responseJson.balance)),
      compensationCreditBalance: Number(responseJson.loyalty_credit_amount)
        ? Number(responseJson.loyalty_credit_amount)
        : 0,
    });
  };

  receiveGoldenPoints = (responseJson: { data: any }) => {
    const previousTransaction =
      this.props.order &&
      this.props.order.order_transactions.find(
        (item) =>
          item.attributes.payment_method.id === this.getWalletPaymentId()
      );
    this.setState({
      goldenpointBalance: responseJson?.data?.balance
        ? responseJson.data.balance
        : 0,
      goldenpointApplicableBalance: responseJson?.data?.applicable_golden_points
        ? responseJson.data.applicable_golden_points
        : 0,
      expiredGoldenPoints: responseJson?.data?.expired_points
        ? responseJson.data.expired_points
        : 0,
        free_wash_quantity: responseJson?.data?.free_wash_quantity
        ? responseJson.data.free_wash_quantity
        : 0,
        free_wash_amount: responseJson?.data?.free_wash_amount
        ? responseJson.data.free_wash_amount
        : 0,
        edit_order: responseJson?.data?.edit_order,
        bonusPoints: responseJson?.data?.bonus_points,
      goldenpointDetails: responseJson?.data ?? null,
      // customPaymentAmount: responseJson.payable_balance + "",
    });
  };

  receiveMakePayment = (responseJson: {
    status: number;
    errors: string;
    order_status: string;
    qitaf_response_status: string;
    qitaf_transaction_type: string;
    mokkafa_response_status: string;
    mokkafa_transaction_type: string;
    message: string;
    data?: {
      data: PaymentTransactionData[];
    };
  }) => {
    // if (
    //   responseJson.qitaf_response_status === "success" &&
    //   responseJson.qitaf_transaction_type === "otp"
    // ) {
    //   this.setState({
    //     showOtpScreen: true,
    //     isPayButtonClicked: false,
    //     otpAttemptRights: true, 
    //     isButtonDisabled: false,
    //   });
    //   return;
    // }
    if (responseJson.order_status === "placed") {
      this.props.onPaymentDone(responseJson?.data?.data || []);
    }
    if (responseJson?.status == 422) {
      this.setState({
        errorSnackbarOpen: true,
        errorMessage: responseJson?.errors,
      });
    } else {
      this.setState({
        successMessage: responseJson.message,
      });
    }

    this.setState({ isPayButtonClicked: false, walletVerified: false });

    setTimeout(() => {
      this.setState({
        selectedSecondPaymentMethod: "",
      });
    }, 1000);
  };

  receiveLateDeliveryConfigs = (responseJson: {
    data: ILateDeliveryConfig[];
  }) => {
    if (responseJson && responseJson.data) {
      this.setState({
        lateDeliveryConfigs: responseJson.data.filter(
          (config) => config.attributes.is_active
        ),
      });
    }
  };

  async receive(from: string, message: Message) {
    if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
      const apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );
      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );
      if (apiRequestCallId === this.getRewardsCallId) {
        this.receiveRewardCall(responseJson);
      } else if (apiRequestCallId === this.redeemAllPointsCallId) {
        this.receiveRedeemAllPoints(responseJson);
      } else if (apiRequestCallId === this.sendOtpCallId) {
        this.receiveOtpMessage(responseJson);
      } else if (apiRequestCallId === this.getPaymentMethodsCallId) {
        this.receivePaymentMethods(responseJson);
      } else if (apiRequestCallId === this.getRemainBalanceCallId) {
        this.receiveRemainBalance(responseJson);
      } else if (apiRequestCallId === this.getWalletBalanceCallId) {
        this.receiveWalletBalance(responseJson);
      } else if (apiRequestCallId === this.getGoldenPointsCallId) {
        this.receiveGoldenPoints(responseJson);
      } else if (apiRequestCallId === this.makePaymentCallId) {
        this.receiveMakePayment(responseJson);
      } else if (apiRequestCallId === this.getLateDeliveryConfigsCallId) {
        this.receiveLateDeliveryConfigs(responseJson);
      } else if (apiRequestCallId === this.getOrderDetailsCallId) {
        this.handleOrderResponse(responseJson);
      } else if (apiRequestCallId === this.applyBonusPointCallId) {
        this.handleApplyDiscountResponse(responseJson);
      } else if (apiRequestCallId === this.getGoldenPointsListCallID) {
        this.handleCustomerGoldenPointList(responseJson);
      } else if (apiRequestCallId === this.sendWalletVerifyOtpCallId) {
        this.receiveSendWalletVerifyOtp(responseJson);
        return;
      } else if (apiRequestCallId === this.verifyWalletCallId) {
        this.receiveVerifyWallet(responseJson);
        return;
      } else if (apiRequestCallId === this.getPaymentReferenceCallId) {
        this.receivePaymentReference(responseJson);
      }

      this.setState({ loading: false });
    }
  }

  onChangeTab(keyID: string | number, name: string) {
     
    const shouldShowOtp = this.state.qitaf_otp_time === true && keyID === 6;
    if (shouldShowOtp) {
      this.setState({ showOtpScreen: true });
    }
    this.setState({
      activeTab: keyID,
      paymentMathod: name,
      shouldUseGoldenPoints: false,
    });
    const { fromUnpaid } = this.props;
    if (!this.state.secondPaymentEnabled ) {
      this.applyGoldenPoints(false);
    }
  }

  onSelectSecondPayments(keyID: string,item: IPaymentMethod) {

    this.setState({ selectedSecondPaymentMethod: keyID });
    this.setState({
    selectedSecondPaymentMethod: keyID, 
    selectedSecondPaymentMethodID: item.id, 
  });
  }

  onChangeAmountToPay(
    activeTab: number | string,
    originalValue: number | string,
    walletBalance: number,
    // compensationCreditBalance: number,
    goldenpointBalance: number,
    goldenpointApplicableBalance: number,
    expiredGoldenPoints: number,
    remainBalance: number
  ) {
    let valueStr = originalValue.toString();
    let valueNum = Number(valueStr);

    const totalAvailable =
      Number(walletBalance || 0) + Number(goldenpointBalance || 0);

    if (!isNaN(valueNum)) {
      if (activeTab === this.getWalletPaymentId()) {
        if (valueNum > remainBalance) {
          valueStr = remainBalance.toString();
        }
      }

      if (valueNum > Number(remainBalance)) {
        valueStr = remainBalance.toString();
      }
    }

    this.setState({ customPaymentAmount: valueStr });
  }

  onKeyPressInput(keyID: string, preventDefault: Function, prevented: boolean) {
    if (
      !(
        (keyID >= "0" && keyID <= "9") ||
        keyID === "." ||
        keyID === "Backspace"
      )
    ) {
      !prevented && preventDefault && preventDefault();
    }
  }

  handleLateDeliverySelection = (configId: string) => {
    this.setState({
      selectedLateDeliveryConfig:
        this.state.selectedLateDeliveryConfig === configId ? null : configId,
    });
  };

  // Customizable Area End
}
// Customizable Area Start

// Customizable Area End
